import axios from 'axios';
import CostHelpType, { CostHelpTypeRequest } from '../entity/cost-help-type.entity';

export default class CostHelpTypeService {
  public static async getAll(): Promise<CostHelpType[]> {
    return axios.get('/api/cost-help-types')
      .then(response => response.data.map((item: any) => new CostHelpType(item)));
  }

  public static async create(costHelpType: CostHelpTypeRequest): Promise<CostHelpType> {
    return axios.post('/api/cost-help-types', costHelpType)
      .then(response => new CostHelpType(response.data));
  }

  public static async update(id: string, costHelpType: CostHelpTypeRequest): Promise<CostHelpType> {
    return axios.put(`/api/cost-help-types/${id}`, costHelpType)
      .then(response => new CostHelpType(response.data));
  }

  public static async delete(id: string): Promise<void> {
    return axios.delete(`/api/cost-help-types/${id}`);
  }

  public static async activate(id: string): Promise<CostHelpType> {
    return axios.patch(`/api/cost-help-types/${id}/activate`)
      .then(response => new CostHelpType(response.data));
  }
}
